import { render, staticRenderFns } from "./SfAddToCart.vue?vue&type=template&id=1e13d9b3&"
import script from "./SfAddToCart.vue?vue&type=script&lang=js&"
export * from "./SfAddToCart.vue?vue&type=script&lang=js&"
import style0 from "./SfAddToCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports